export const instagramCacheIsExpired = expiration => {
  const miliPerHour = 3600000
  return Date.now() - expiration > miliPerHour
}
